import React, { useState, useEffect, useRef } from 'react';
import { Plus, X, Search, Wrench, Gem, Scale, RefreshCw, FileText, Check, Clock, Eye } from 'lucide-react';
import { API_URL } from '../../services/api';

const API = API_URL;
const hdrs = () => ({ 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' });

const TYPES = [
  { id: 'reparation', label: 'OS', icon: '🔧', color: 'orange' },
  { id: 'gravure', label: 'Gravure', icon: '✍️', color: 'purple' },
  { id: 'estimation', label: 'Estimation', icon: '🔍', color: 'blue' },
  { id: 'rachat_or', label: "Rachat d'or", icon: '🥇', color: 'yellow' },
  { id: 'consignation', label: 'Consignation', icon: '🏷️', color: 'green' },
];

const STATUTS = {
  reception: { label: 'Reception', bg: 'bg-gray-100 text-gray-700' },
  devis_envoye: { label: 'Devis envoye', bg: 'bg-blue-100 text-blue-700' },
  accepte: { label: 'Accepte', bg: 'bg-indigo-100 text-indigo-700' },
  en_cours: { label: 'En cours', bg: 'bg-amber-100 text-amber-700' },
  termine: { label: 'Termine', bg: 'bg-green-100 text-green-700' },
  livre: { label: 'Livre', bg: 'bg-purple-100 text-purple-700' },
  annule: { label: 'Annule', bg: 'bg-red-100 text-red-700' },
};

export default function ServicesSAV() {
  const [services, setServices] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [filtreType, setFiltreType] = useState('');
  const [filtreStatut, setFiltreStatut] = useState('');
  const [search, setSearch] = useState('');
  const [showCreate, setShowCreate] = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [form, setForm] = useState({ type_service: 'reparation', client_nom: '', client_telephone: '', description_bijou: '', description_probleme: '', origine: 'externe', poids_or_recu: '', devis_montant: '', delai_estime_jours: '', notes: '', valeur_estimee: '', prix_rachat: '' });
  const [refInterne, setRefInterne] = useState('');
  const [bijouTrouve, setBijouTrouve] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [dropdownStyle, setDropdownStyle] = useState({});
  const refInputRef = useRef(null);
  const suggestionsRef = useRef(null);

  useEffect(() => { loadData(); }, [filtreType, filtreStatut]);

  const loadData = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (filtreType) params.append('type', filtreType);
      if (filtreStatut) params.append('statut', filtreStatut);
      if (search) params.append('search', search);
      const [sRes, stRes] = await Promise.all([
        fetch(`${API}/services?${params}`, { headers: hdrs() }),
        fetch(`${API}/services/stats`, { headers: hdrs() }),
      ]);
      setServices(Array.isArray(await sRes.json().then(d => d)) ? await (await fetch(`${API}/services?${params}`, { headers: hdrs() })).json() : []);
      const stData = await stRes.json();
      setStats(stData || {});
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => {
    const load = async () => {
      try {
        const params = new URLSearchParams();
        if (filtreType) params.append('type', filtreType);
        if (filtreStatut) params.append('statut', filtreStatut);
        if (search) params.append('search', search);
        const r = await fetch(`${API}/services?${params}`, { headers: hdrs() });
        const d = await r.json();
        setServices(Array.isArray(d) ? d : []);
      } catch {}
    };
    load();
  }, [filtreType, filtreStatut, search]);

  const creerService = async () => {
    try {
      const r = await fetch(`${API}/services`, { method: 'POST', headers: hdrs(), body: JSON.stringify(form) });
      const d = await r.json();
      if (r.ok) {
        alert(`${d.numero} cree avec succes`);
        setShowCreate(false);
        setBijouTrouve(null);
        setRefInterne('');
        setSuggestions([]);
        setShowSuggestions(false);
        setForm({ type_service: 'reparation', client_nom: '', client_telephone: '', description_bijou: '', description_probleme: '', origine: 'externe', poids_or_recu: '', devis_montant: '', delai_estime_jours: '', notes: '', valeur_estimee: '', prix_rachat: '' });
        loadData();
      } else alert(d.error || 'Erreur');
    } catch (e) { alert(e.message); }
  };

  const changerStatut = async (id, statut) => {
    await fetch(`${API}/services/${id}`, { method: 'PUT', headers: hdrs(), body: JSON.stringify({ statut }) });
    loadData();
  };

  const fetchSuggestions = async (val) => {
    if (val.length < 2) { setSuggestions([]); setShowSuggestions(false); return; }
    try {
      const r = await fetch(`${API}/bijoux/search-ref?q=${encodeURIComponent(val)}`, { headers: hdrs() });
      if (r.ok) {
        const d = await r.json();
        const list = Array.isArray(d) ? d : [];
        setSuggestions(list);
        if (list.length > 0 && refInputRef.current) {
          const rect = refInputRef.current.getBoundingClientRect();
          setDropdownStyle({ position: 'fixed', top: rect.bottom + 4, left: rect.left, width: rect.width, zIndex: 9999 });
          setShowSuggestions(true);
        } else {
          setShowSuggestions(false);
        }
      }
    } catch { setSuggestions([]); setShowSuggestions(false); }
  };

  const selectSuggestion = (bijou) => {
    setRefInterne(bijou.reference);
    setSuggestions([]);
    setShowSuggestions(false);
    setBijouTrouve(bijou);
    setForm(f => ({
      ...f,
      description_bijou: `${bijou.nom || bijou.reference} — ${bijou.categorie || ''} ${bijou.couleur_or || ''} ${bijou.matiere || ''}`.trim(),
      bijou_id: bijou.id,
      reference_bijou: bijou.reference,
      origine: 'interne'
    }));
  };


return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-800">Services & SAV</h2>
        <button onClick={() => setShowCreate(true)}
          className="w-full sm:w-auto flex items-center justify-center gap-2 px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-semibold text-sm">
          <Plus className="h-4 w-4" /> Nouveau service
        </button>
      </div>

      {/* Stats par type */}
      <div className="overflow-x-auto -mx-1 px-1">
      <div className="grid grid-cols-5 gap-3 min-w-[400px]">
        {TYPES.map(t => {
          const s = stats[t.id] || {};
          return (
            <button key={t.id} onClick={() => setFiltreType(filtreType === t.id ? '' : t.id)}
              className={`p-3 rounded-xl border-2 text-center transition-all ${filtreType === t.id ? 'border-purple-500 bg-purple-50' : 'border-gray-200 hover:border-gray-300'}`}>
              <div className="text-2xl mb-1">{t.icon}</div>
              <div className="text-xs font-semibold text-gray-700">{t.label}</div>
              <div className="text-lg font-bold text-gray-900">{s.total || 0}</div>
              {s.en_cours > 0 && <div className="text-xs text-amber-600">{s.en_cours} en cours</div>}
            </button>
          );
        })}
      </div>
      </div>

      {/* Filtres */}
      <div className="flex gap-3">
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <input type="text" value={search} onChange={e => setSearch(e.target.value)}
            placeholder="Rechercher par numero, client, bijou..."
            className="w-full pl-9 pr-4 py-2 border border-gray-300 rounded-lg text-sm" />
        </div>
        <select value={filtreStatut} onChange={e => setFiltreStatut(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-lg text-sm">
          <option value="">Tous statuts</option>
          {Object.entries(STATUTS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
      </div>

      {/* Mobile cards — services */}
      <div className="md:hidden space-y-3">
        {services.length === 0 ? (
          <div className="p-8 text-center text-gray-400">{loading ? 'Chargement...' : 'Aucun service'}</div>
        ) : services.map(s => {
          const type = TYPES.find(t => t.id === s.type_service) || {};
          const statut = STATUTS[s.statut] || { label: s.statut, bg: 'bg-gray-100' };
          return (
            <div key={s.id} className="bg-white rounded-lg shadow p-4 border-l-4 border-purple-400">
              <div className="flex justify-between items-start mb-2">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-lg">{type.icon}</span>
                    <span className="font-mono font-bold text-sm text-purple-700">{s.numero_service}</span>
                  </div>
                  <div className="text-sm font-medium text-gray-800 mt-0.5">{s.client_nom || 'Client'}</div>
                  <div className="text-xs text-gray-500">{s.description_bijou || s.description_probleme || '—'}</div>
                </div>
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statut.bg}`}>{statut.label}</span>
              </div>
              <div className="flex justify-between items-center mt-2">
                <div className="text-sm">
                  {s.montant_final > 0 ? (
                    <span className="font-bold text-green-600">{parseFloat(s.montant_final).toLocaleString('fr-FR')} DH</span>
                  ) : s.devis_montant > 0 ? (
                    <span className="text-gray-500 text-xs">Devis: {parseFloat(s.devis_montant).toLocaleString('fr-FR')} DH</span>
                  ) : (
                    <span className="text-xs text-gray-400">{s.date_reception ? new Date(s.date_reception).toLocaleDateString('fr-FR') : ''}</span>
                  )}
                </div>
                <div className="flex gap-1">
                  {s.statut === 'reception' && (
                    <button onClick={() => changerStatut(s.id, 'en_cours')} className="px-3 py-1.5 rounded-lg bg-amber-100 text-amber-700 text-xs font-medium">Démarrer</button>
                  )}
                  {s.statut === 'en_cours' && (
                    <button onClick={() => changerStatut(s.id, 'termine')} className="px-3 py-1.5 rounded-lg bg-green-100 text-green-700 text-xs font-medium">Terminer</button>
                  )}
                  {s.statut === 'termine' && (
                    <button onClick={() => changerStatut(s.id, 'livre')} className="px-3 py-1.5 rounded-lg bg-purple-100 text-purple-700 text-xs font-medium">Livrer</button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Liste desktop */}
      <div className="hidden md:block bg-white rounded-xl shadow-sm border">
        {services.length === 0 ? (
          <div className="p-12 text-center text-gray-400">
            {loading ? 'Chargement...' : 'Aucun service'}
          </div>
        ) : (
          <div className="divide-y">
            {services.map(s => {
              const type = TYPES.find(t => t.id === s.type_service) || {};
              const statut = STATUTS[s.statut] || { label: s.statut, bg: 'bg-gray-100' };
              return (
                <div key={s.id} className="flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors">
                  <div className="text-2xl w-10 text-center">{type.icon}</div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="font-mono font-bold text-sm text-purple-700">{s.numero_service}</span>
                      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statut.bg}`}>{statut.label}</span>
                    </div>
                    <div className="text-sm text-gray-800 font-medium truncate">{s.client_nom || 'Client'}</div>
                    <div className="text-xs text-gray-500 truncate">{s.description_bijou || s.description_probleme || '—'}</div>
                  </div>
                  <div className="text-right text-sm">
                    {s.montant_final > 0 ? (
                      <div className="font-bold text-green-600">{parseFloat(s.montant_final).toLocaleString('fr-FR')} DH</div>
                    ) : s.devis_montant > 0 ? (
                      <div className="text-gray-500">Devis: {parseFloat(s.devis_montant).toLocaleString('fr-FR')} DH</div>
                    ) : null}
                    {s.poids_or_recu > 0 && <div className="text-xs text-amber-600">{s.poids_or_recu}g or</div>}
                    <div className="text-xs text-gray-400">{s.date_reception ? new Date(s.date_reception).toLocaleDateString('fr-FR') : ''}</div>
                  </div>
                  <div className="flex gap-1">
                    {s.statut === 'reception' && (
                      <button onClick={() => changerStatut(s.id, 'en_cours')} className="p-1.5 rounded bg-amber-100 text-amber-700 hover:bg-amber-200" title="Demarrer"><Wrench className="h-3.5 w-3.5" /></button>
                    )}
                    {s.statut === 'en_cours' && (
                      <button onClick={() => changerStatut(s.id, 'termine')} className="p-1.5 rounded bg-green-100 text-green-700 hover:bg-green-200" title="Terminer"><Check className="h-3.5 w-3.5" /></button>
                    )}
                    {s.statut === 'termine' && (
                      <button onClick={() => changerStatut(s.id, 'livre')} className="p-1.5 rounded bg-purple-100 text-purple-700 hover:bg-purple-200" title="Livrer"><FileText className="h-3.5 w-3.5" /></button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Modal creation */}
      {showCreate && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-end sm:items-center justify-center p-0 sm:p-4">
          <div className="bg-white rounded-t-2xl sm:rounded-xl shadow-2xl w-full max-w-lg max-h-[95vh] sm:max-h-[90vh] overflow-y-auto p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold">Nouveau service</h3>
              <button onClick={() => setShowCreate(false)}><X className="h-5 w-5 text-gray-400" /></button>
            </div>

            <div className="space-y-4">
              {/* Type */}
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-2">Type de service</label>
                <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
                  {TYPES.map(t => (
                    <button key={t.id} onClick={() => setForm({ ...form, type_service: t.id })}
                      className={`p-2 rounded-lg border-2 text-center text-xs font-medium transition-all ${form.type_service === t.id ? 'border-purple-500 bg-purple-50' : 'border-gray-200'}`}>
                      <div className="text-lg">{t.icon}</div>
                      {t.label}
                    </button>
                  ))}
                </div>
              </div>

              {/* Client */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Client</label>
                  <input type="text" value={form.client_nom} onChange={e => setForm({ ...form, client_nom: e.target.value })}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="Nom du client" />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Telephone</label>
                  <input type="text" value={form.client_telephone} onChange={e => setForm({ ...form, client_telephone: e.target.value })}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="06..." />
                </div>
              </div>

              {/* Origine */}
              <div className="flex gap-3">
                {['externe', 'interne'].map(o => (
                  <button key={o} type="button" onClick={() => { setForm(f => ({ ...f, origine: o })); setBijouTrouve(null); setRefInterne(''); setSuggestions([]); setShowSuggestions(false); }}
                    className={`flex-1 py-2 rounded-lg border-2 text-sm font-medium transition-all ${form.origine === o ? 'border-purple-500 bg-purple-50 text-purple-700' : 'border-gray-200 text-gray-600'}`}>
                    {o === 'externe' ? '🔗 Bijou client externe' : '🏪 Bijou de notre boutique'}
                  </button>
                ))}
              </div>

              {/* Bijou de notre boutique — recherche par référence unique */}
              {form.origine === 'interne' ? (
                <div className="space-y-3">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">
                      Référence unique du bijou <span className="text-gray-400 font-normal">— tapez pour chercher</span>
                    </label>
                    <input
                      ref={refInputRef}
                      type="text"
                      value={refInterne}
                      onChange={e => {
                        const val = e.target.value;
                        setRefInterne(val);
                        setBijouTrouve(null);
                        fetchSuggestions(val);
                      }}
                      onKeyDown={e => { if (e.key === 'Escape') setShowSuggestions(false); }}
                      onBlur={() => setTimeout(() => setShowSuggestions(false), 150)}
                      className="w-full px-3 py-2 border rounded-lg text-sm font-mono"
                      placeholder="Tapez le N° pièce (1.0063) ou le modèle (BAGB21)..."
                      autoComplete="off"
                    />

                    {/* Dropdown en position fixed pour éviter le clipping du modal */}
                    {showSuggestions && suggestions.length > 0 && (
                      <div style={dropdownStyle} className="bg-white border border-purple-200 rounded-xl shadow-2xl overflow-hidden">
                        {suggestions.map(s => (
                          <button
                            key={s.id}
                            type="button"
                            onMouseDown={() => selectSuggestion(s)}
                            className="w-full flex items-center gap-3 px-3 py-2.5 hover:bg-purple-50 transition-colors text-left border-b border-gray-100 last:border-0"
                          >
                            {s.image_url ? (
                              <img src={s.image_url.startsWith('/') ? `${API.replace('/api','')}${s.image_url}` : s.image_url}
                                alt="" className="w-10 h-10 object-contain rounded-lg border border-gray-200 bg-gray-50 flex-shrink-0" />
                            ) : (
                              <div className="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center flex-shrink-0 text-lg">💍</div>
                            )}
                            <div className="flex-1 min-w-0">
                              <div className="flex items-center gap-2 flex-wrap">
                                {/* N° pièce unique — le plus important */}
                                <span className="font-mono text-sm font-bold text-purple-800 bg-purple-100 px-2 py-0.5 rounded-lg">{s.id_produit || s.reference}</span>
                                {/* Modèle */}
                                {s.reference_article && <span className="text-xs text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded font-medium">{s.reference_article}</span>}
                                {/* Statut dispo */}
                                <span className={`text-xs px-1.5 py-0.5 rounded font-medium ${s.inventaire_actif ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-600'}`}>
                                  {s.inventaire_actif ? 'Dispo' : 'Vendu'}
                                </span>
                              </div>
                              <div className="text-sm text-gray-800 font-medium truncate mt-0.5">{s.nom}</div>
                              <div className="flex gap-1.5 mt-0.5">
                                {s.categorie && <span className="text-xs text-gray-500 capitalize">{s.categorie}</span>}
                                {s.couleur_or && <span className="text-xs text-gray-400">· Or {s.couleur_or}</span>}
                                {(s.poids_reel || s.poids_final_sans_pierres) && <span className="text-xs text-gray-400">· {parseFloat(s.poids_reel || s.poids_final_sans_pierres).toFixed(2)}g</span>}
                              </div>
                            </div>
                            {s.prix_vente > 0 && (
                              <div className="text-sm font-bold text-green-600 flex-shrink-0">
                                {parseFloat(s.prix_vente).toLocaleString('fr-FR')} DH
                              </div>
                            )}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Carte bijou trouvé */}
                  {bijouTrouve && bijouTrouve.id && (
                    <div className="bg-green-50 border-2 border-green-400 rounded-xl p-4 flex gap-4 items-start">
                      {bijouTrouve.image_url && (
                        <img src={bijouTrouve.image_url.startsWith('/') ? `${API.replace('/api','')}${bijouTrouve.image_url}` : bijouTrouve.image_url}
                          alt="" className="w-16 h-16 object-contain rounded-lg border border-green-200 bg-white" />
                      )}
                      <div className="flex-1 min-w-0">
                        <div className="font-bold text-green-800 text-sm">{bijouTrouve.nom || bijouTrouve.reference}</div>
                        {/* N° pièce unique + modèle clairement séparés */}
                        <div className="flex items-center gap-2 mt-1 flex-wrap">
                          <span className="font-mono text-xs font-bold text-purple-800 bg-purple-100 px-2 py-0.5 rounded-lg">
                            {bijouTrouve.id_produit || bijouTrouve.reference}
                          </span>
                          {bijouTrouve.reference_article && (
                            <span className="text-xs text-gray-600 bg-gray-100 px-2 py-0.5 rounded font-medium">
                              Modèle : {bijouTrouve.reference_article}
                            </span>
                          )}
                        </div>
                        <div className="flex flex-wrap gap-2 mt-2">
                          {bijouTrouve.categorie && <span className="text-xs bg-white border border-green-300 text-green-700 px-2 py-0.5 rounded-full capitalize">{bijouTrouve.categorie}</span>}
                          {bijouTrouve.couleur_or && <span className="text-xs bg-white border border-green-300 text-green-700 px-2 py-0.5 rounded-full">Or {bijouTrouve.couleur_or}</span>}
                          {(bijouTrouve.poids_reel || bijouTrouve.poids_final_sans_pierres) && <span className="text-xs bg-white border border-green-300 text-green-700 px-2 py-0.5 rounded-full">{parseFloat(bijouTrouve.poids_reel || bijouTrouve.poids_final_sans_pierres).toFixed(2)}g</span>}
                          {bijouTrouve.collection_nom && <span className="text-xs bg-white border border-purple-300 text-purple-700 px-2 py-0.5 rounded-full">✦ {bijouTrouve.collection_nom}</span>}
                        </div>
                        {bijouTrouve.prix_vente > 0 && <div className="text-xs text-green-700 font-semibold mt-1">{parseFloat(bijouTrouve.prix_vente).toLocaleString('fr-FR')} DH</div>}
                      </div>
                      <button type="button" onClick={() => { setBijouTrouve(null); setRefInterne(''); setForm(f => ({ ...f, description_bijou: '', bijou_id: null, reference_bijou: null })); }}
                        className="text-gray-400 hover:text-red-500 flex-shrink-0">
                        <X className="h-4 w-4" />
                      </button>
                    </div>
                  )}

                  {/* Note SAV */}
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Note — que faut-il faire ?</label>
                    <textarea value={form.description_probleme} onChange={e => setForm({ ...form, description_probleme: e.target.value })}
                      className="w-full px-3 py-2 border rounded-lg text-sm resize-none" rows={3}
                      placeholder="Ex: Changer le fermoir, nettoyer et polir, resserrer la pierre, gravure à ajouter..." />
                  </div>
                </div>
              ) : (
                /* Bijou externe */
                <div className="space-y-3">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Description du bijou</label>
                    <input type="text" value={form.description_bijou} onChange={e => setForm({ ...form, description_bijou: e.target.value })}
                      className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="Ex: Bague or 18k avec diamant, collier argent..." />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Note — que faut-il faire ?</label>
                    <textarea value={form.description_probleme} onChange={e => setForm({ ...form, description_probleme: e.target.value })}
                      className="w-full px-3 py-2 border rounded-lg text-sm resize-none" rows={3}
                      placeholder="Ex: Changer le fermoir, nettoyer et polir, resserrer la pierre..." />
                  </div>
                </div>
              )}

              {form.type_service === 'rachat_or' && (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Poids or (g)</label>
                    <input type="text" value={form.poids_or_recu} onChange={e => setForm({ ...form, poids_or_recu: e.target.value.replace(',', '.') })}
                      className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="0.00" />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Prix rachat (DH)</label>
                    <input type="text" value={form.prix_rachat} onChange={e => setForm({ ...form, prix_rachat: e.target.value.replace(',', '.') })}
                      className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="0.00" />
                  </div>
                </div>
              )}

              {form.type_service === 'estimation' && (
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Valeur estimee (DH)</label>
                  <input type="text" value={form.valeur_estimee} onChange={e => setForm({ ...form, valeur_estimee: e.target.value.replace(',', '.') })}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="0.00" />
                </div>
              )}

              {/* Devis + Delai */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Devis montant (DH)</label>
                  <input type="text" value={form.devis_montant} onChange={e => setForm({ ...form, devis_montant: e.target.value.replace(',', '.') })}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="0.00" />
                </div>
                <div>
                  <label className="block text-xs font-semibold text-gray-600 mb-1">Delai estime (jours)</label>
                  <input type="text" inputMode="decimal" onFocus={e => e.target.select()} value={form.delai_estime_jours} onChange={e => setForm({ ...form, delai_estime_jours: e.target.value })}
                    className="w-full px-3 py-2 border rounded-lg text-sm" placeholder="7" />
                </div>
              </div>

              {/* Notes */}
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-1">Notes</label>
                <textarea value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })}
                  className="w-full px-3 py-2 border rounded-lg text-sm resize-none" rows={2} />
              </div>
            </div>

            <div className="flex gap-3 mt-6">
              <button onClick={() => { setShowCreate(false); setBijouTrouve(null); setRefInterne(''); setSuggestions([]); setShowSuggestions(false); }} className="flex-1 py-2 bg-gray-100 rounded-lg text-gray-600 font-medium">Annuler</button>
              <button onClick={creerService} className="flex-1 py-2 bg-purple-600 text-white rounded-lg font-semibold hover:bg-purple-700">Creer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
